// This dictionary contains 1 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { localization } from "../localizationManager";

export var spanishStrings = {
  groupButton: "Grupo Por Mí",
  ungroupButton: "Desagrupar por mí",
  selectButton: "Seleccionarme",
  hideColumn: "Ocultar columna",
  showColumn: "Mostrar columna",
  makePrivateColumn: "Hacer que la columna sea privada",
  makePublicColumn: "Hacer pública la columna",
  moveToDetail: "Mover al detalle",
  showAsColumn: "Mostrar como columna",
  filterPlaceholder: "Buscar ...",
  removeRows: "Eliminar filas",
  showLabel: "Mostrar",
  entriesLabel: "Entradas",
  visualizer_text: "Textos en tabla",
  visualizer_wordcloud: "Wordcloud",
  visualizer_histogram: "Histograma",
  visualizer_number: "Promedio",
  visualizer_choices: "Mesa",
  visualizer_selectBase: "Gráfico",
  // visualizer_matrix: "Chart",
  chartType_bar: "Bar",
  chartType_vbar: "Barra vertical",
  chartType_stackedbar: "Barra apilada",
  chartType_doughnut: "Donut",
  chartType_pie: "Pie",
  chartType_scatter: "Dispersión",
  chartType_gauge: "Gauge",
  chartType_bullet: "Bullet",
  hideButton: "Ocultar",
  makePrivateButton: "Hacer privado",
  makePublicButton: "Hacer público",
  showButton: "Mostrar",
  filter: "Filtro",
  resetFilter: "Restablecer filtro",
  changeLocale: "Cambiar configuración regional",
  clearButton: "Borrar",
  addElement: "Elija la pregunta para mostrar ...",
  defaultOrder: "Orden predeterminado",
  ascOrder: "Ascendente",
  descOrder: "Descendente",
  showMinorColumns: "Mostrar columnas secundarias",
  otherCommentTitle: "Otros elementos y comentarios",
  showPercentages: "Mostrar porcentajes",
  hidePercentages: "Ocultar porcentajes",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Descargar el gráfico como png",
  hideEmptyAnswers: "Ocultar respuestas vacías",
  showEmptyAnswers: "Mostrar respuestas vacías",
  "topNValueText-1": "Todas las respuestas",
  topNValueText5: "Las 5 respuestas principales",
  topNValueText10: "Las 10 respuestas principales",
  topNValueText20: "20 respuestas principales",
  hideMissingAnswers: "Ocultar las respuestas que faltan",
  showMissingAnswers: "Mostrar las respuestas que faltan",
  missingAnswersLabel: "Respuestas faltantes",
  noVisualizerForQuestion: "Este tipo de pregunta aún no se visualiza",
  noResults: "Aún no hay resultados",
  showPerValues: "Por valores",
  showPerColumns: "Por columnas",
  answer: "Respuesta",
  correctAnswer: "Respuesta correcta: ",
  percent: "Por ciento",
  responses: "Respuestas"
};
localization.locales["es"] = spanishStrings;
localization.localeNames["es"] = "Español";

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// undefined.groupButton: "Group By Me" => "Grupo Por Mí"
// undefined.entriesLabel: "entries" => "Entradas"
// undefined.visualizer_histogram: "Histogram" => "Histograma"
// undefined.visualizer_number: "Average" => "Promedio"
// undefined.visualizer_choices: "Table" => "Mesa"
// undefined.visualizer_selectBase: "Chart" => "Gráfico"
// undefined.chartType_vbar: "Vertical Bar" => "Barra vertical"
// undefined.hideMissingAnswers: "Hide missing answers" => "Ocultar las respuestas que faltan"
// undefined.showMissingAnswers: "Show missing answers" => "Mostrar las respuestas que faltan"
// undefined.missingAnswersLabel: "Missing answers" => "Respuestas faltantes"
// undefined.showPerValues: "Per Values" => "Por valores"
// undefined.showPerColumns: "Per Columns" => "Por columnas"
// undefined.answer: "Answer" => "Respuesta"
// undefined.correctAnswer: "Correct answer: " => "Respuesta correcta: "
// undefined.percent: "Percent" => "Por ciento"
// undefined.responses: "Responses" => "Respuestas"